import axiosInstance from './axiosInstance'

// Export the Response interface so it can be used in other files
export interface Response<T> {
  rtn_code: string
  rtn_msg: string
  rtn_ext: any
  data: T
  success: boolean
}

/**
 * get 请求
 */
export function getAction<T>(url: string, parameter?: Record<string, any>) {
  return axiosInstance({
    url: url,
    method: 'get',
    params: parameter
  }) as Promise<Response<T>>
}

/**
 * post 请求
 */
export function postAction<T>(url: string, parameter?: Record<string, any>) {
  return axiosInstance({
    url: url,
    method: 'post',
    data: parameter
  }) as Promise<Response<T>>
}

/**
 * put 请求
 */
export function putAction<T>(url: string, parameter: Record<string, any>) {
  return axiosInstance({
    url: url,
    method: 'put',
    data: parameter
  }) as Promise<Response<T>>
}

/**
 * delete 请求
 */
export function deleteAction<T>(url: string, parameter?: Record<string, any>) {
  return axiosInstance({
    url: url,
    method: 'delete',
    params: parameter
  }) as Promise<Response<T>>
}

/**
 * http请求 请求
 */
export function httpAction<T>(url: string, method: string, parameter: Record<string, any>) {
  if (method == 'get' || method == 'delete')
    return axiosInstance({
      url: url,
      method: method,
      params: parameter
    }) as Promise<Response<T>>
  else
    return axiosInstance({
      url: url,
      method: method,
      data: parameter
    }) as Promise<Response<T>>
}
